export default __webpack_public_path__ + "bg_anli_zhengwu02138730.png";